//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class UserGroupModel extends ModelBase {
      static readonly $typeName = 'UserGroupModel';
      public group: LookupModel;
      public IsUniversalGroupAccess:boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/UserGroupModel.ts